import {
  CASE_ACTION_SUBMIT,
  CASE_ACTION_SUBMIT_SUCCESS,
  CASE_ACTION_SUBMIT_FAIL,
  CASE_ACTION_INFO_MODAL_CLOSE,
  CASE_ACTION_CONFIRM_MODAL_OPEN,
  CASE_ACTION_CONFIRM_MODAL_CLOSE,
  CASE_ACTION_INFO_MODAL_CLOSE_WITHOUT_RENDER
} from '../../actions/cm/caseAction';

import {
  RELOAD_CASE_DETAILS,
  FETCH_CASE_DETAILS_BY_CASE_ID
} from '../../actions/cm/caseDetails';

export const initialState = {
  isLoading: false,
  hasError: false,
  errorMessage: null,
  showInfoModal: false,
  showConfirmModal: false,
  renderCount: 0
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CASE_ACTION_SUBMIT:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: null
      };
    case CASE_ACTION_SUBMIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showInfoModal: true,
        showConfirmModal: false
      };
    case CASE_ACTION_SUBMIT_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload?.errorMessage || null,
        showConfirmModal: false
      };
    case CASE_ACTION_INFO_MODAL_CLOSE:
      return {
        ...state,
        showInfoModal: false,
        renderCount: state.renderCount + 1
      };
    case CASE_ACTION_CONFIRM_MODAL_OPEN:
      return {
        ...state,
        showConfirmModal: true
      };
    case CASE_ACTION_CONFIRM_MODAL_CLOSE:
      return {
        ...state,
        showConfirmModal: false
      };

    case RELOAD_CASE_DETAILS:
    case FETCH_CASE_DETAILS_BY_CASE_ID:
      return {
        ...state,
        showInfoModal: false,
        showConfirmModal: false,
        hasError: false,
        errorMessage: null
      };
    case CASE_ACTION_INFO_MODAL_CLOSE_WITHOUT_RENDER:
      return {
        ...state,
        showInfoModal: false
      };
    default:
      return state;
  }
}
